import styled from 'styled-components';

export const ButtonsContainer = styled.div`
  width: 90vw;
  height: 10vh;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: auto;
`;

export const RecipesContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 95%;
  margin: auto;
  gap: 1rem;
  flex-wrap: wrap;
`;
